import _ from 'lodash';

export function encodeQueryParams(object: any) {
  return _.map(object, (value, key) => {
    if (_.isObject(value)) {
      value = JSON.stringify(value);
    }
    return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
  }).join('&');
}
